<template>
    <div id="Unassigned_Visits" class="dashboard-card d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template #header>
                <section class="card-title">
                    <span>Unassigned Visits (Next 7 Days)</span>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template #content>
                <div class="mt-3 text-center" v-if="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading your unassigned visit count</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-if="hasError && !isLoading">
                    <p>
                        There was a problem while fetching your unassigned visit count.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getVisitCount()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <section v-if="visitCounts.length === 0 && !isLoading && !hasError" class="no-data">
                    <i class="mb-3"> Good Job! There were no unassigned visit count. </i>
                </section>
                <!-- DATA -->
                <div class="h-100 overflow-auto position-relative w-100 d-flex align-items-center p-2 active-patients">
                    <Chart type="pie" :data="chartData" :options="chartOptions" />
                    <div class="legend ms-4">
                        <table>
                            <tr
                                v-for="visit in visitCounts"
                                :key="visit.Application"
                                :class="
                                    ApplicationNamesEnum.getDescriptionUsingValue(visit.Application) == active.label
                                        ? getProductColorClass(active.label)
                                        : 'text-black'
                                "
                            >
                                <td v-if="visit.Application !== ApplicationEnum.AgencyCore">
                                    {{ ApplicationNamesEnum.getDescriptionUsingValue(visit.Application) }}
                                </td>
                                <td class="ps-3"></td>
                                <td class="ps-2"></td>
                                <a
                                    href="javascript:void(0);"
                                    v-if="visit.Application !== ApplicationEnum.AgencyCore"
                                    @click="redirectToUnassignedVisit(visit.Application)"
                                    class="no-tag-color"
                                >
                                    <td>{{ visit.Counts.UnassignedVisitCount }}</td>
                                </a>
                            </tr>
                        </table>
                    </div>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./UnassignedVisits.ts"></script>
